(function () {
  'use strict';

  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var timer = null;
  var initTries = 0;

  function bars() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-cnc-gift-bar]')
    );
  }

  function money(cents, currency) {
    var whole = cents % 100 === 0;
    var amount = (cents / 100).toFixed(whole ? 0 : 2);
    return amount + ' ' + currency;
  }

  function render(cart) {
    bars().forEach(function (bar) {
      var ship = parseInt(bar.getAttribute('data-shipping-threshold'), 10);
      var gift = parseInt(bar.getAttribute('data-gift-threshold'), 10);
      var giftPos = parseFloat(bar.getAttribute('data-gift-pos')) || 100;
      var currency = cart.currency || bar.getAttribute('data-currency') || 'EUR';
      var msg = bar.querySelector('[data-cnc-gift-msg]');
      var fill = bar.querySelector('[data-cnc-gift-fill]');
      var subtotal = cart.items_subtotal_price;

      if (!cart.item_count) {
        if (bar.getAttribute('data-context') === 'drawer') {
          bar.hidden = true;
          return;
        }
        bar.hidden = false;
        fill.style.width = '0%';
        msg.innerHTML =
          'You are <strong>' +
          money(ship, currency) +
          '</strong> away from Free Shipping!';
      } else {
        bar.hidden = false;
        if (subtotal >= gift) {
          fill.style.width = '100%';
        } else {
          fill.style.width =
            Math.min(giftPos, (subtotal / gift) * giftPos) + '%';
        }
        if (subtotal < ship) {
          msg.innerHTML =
            'You are <strong>' +
            money(ship - subtotal, currency) +
            '</strong> away from Free Shipping!';
        } else if (subtotal < gift) {
          msg.innerHTML =
            'You are <strong>' +
            money(gift - subtotal, currency) +
            '</strong> away from Free Gift!';
        } else {
          msg.textContent = 'Free shipping + your free CurlCare Cloth unlocked!';
        }
      }

      var milestones = bar.querySelectorAll('[data-cnc-milestone]');
      for (var i = 0; i < milestones.length; i++) {
        var value = parseInt(milestones[i].getAttribute('data-cnc-milestone'), 10);
        if (cart.item_count && subtotal >= value) {
          milestones[i].classList.add('is-reached');
        } else {
          milestones[i].classList.remove('is-reached');
        }
      }
    });

    renderUpsell(cart);
  }

  function upsellWraps() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-cnc-upsell]')
    );
  }

  function updateUpsellNav(wrap) {
    var vp = wrap.querySelector('[data-cnc-upsell-viewport]');
    var prev = wrap.querySelector('[data-cnc-upsell-nav="prev"]');
    var next = wrap.querySelector('[data-cnc-upsell-nav="next"]');
    if (!vp || !prev || !next) return;
    var max = vp.scrollWidth - vp.clientWidth;
    prev.disabled = max <= 2 || vp.scrollLeft <= 2;
    next.disabled = max <= 2 || vp.scrollLeft >= max - 2;
  }

  function onUpsellClick(e) {
    if (!e.target || !e.target.closest) return;
    var add = e.target.closest('[data-cnc-upsell-add]');
    if (add) {
      addUpsellItem(add);
      return;
    }
    var nav = e.target.closest('[data-cnc-upsell-nav]');
    if (nav && !nav.disabled) {
      var wrap = nav.closest('[data-cnc-upsell]');
      var vp = wrap && wrap.querySelector('[data-cnc-upsell-viewport]');
      if (vp) {
        var dir = nav.getAttribute('data-cnc-upsell-nav') === 'next' ? 1 : -1;
        vp.scrollBy({ left: dir * vp.clientWidth, behavior: 'smooth' });
      }
    }
  }

  function bindUpsell(wrap) {
    if (wrap.cncUpsellBound) return;
    wrap.cncUpsellBound = true;
    wrap.addEventListener('click', onUpsellClick);
    var vp = wrap.querySelector('[data-cnc-upsell-viewport]');
    if (!vp) return;
    vp.addEventListener('scroll', function () {
      updateUpsellNav(wrap);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        updateUpsellNav(wrap);
      }).observe(vp);
    }
  }

  function renderUpsell(cart) {
    upsellWraps().forEach(function (wrap) {
      bindUpsell(wrap);
      wrap.hidden = !cart.item_count;
      updateUpsellNav(wrap);
    });
  }

  function addUpsellItem(btn) {
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id || btn.disabled) return;
    btn.disabled = true;
    var label = btn.innerHTML;
    btn.textContent = '...';
    nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.sections) announce(data);
      })
      .catch(function () {})
      .then(function () {
        btn.disabled = false;
        btn.innerHTML = label;
        refresh();
      });
  }

  function announce(data) {
    document.body.dispatchEvent(
      new CustomEvent('cascade:modalcart:cartqtychange', {
        bubbles: true,
        detail: { response: data }
      })
    );
  }

  function sync(cart) {
    var bar = bars()[0];
    if (!bar || busy) return;

    var giftVariant = parseInt(bar.getAttribute('data-gift-variant'), 10);
    var gift = parseInt(bar.getAttribute('data-gift-threshold'), 10);

    var line = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === giftVariant) {
        line = cart.items[i];
        break;
      }
    }

    var othersCount = cart.item_count - (line ? line.quantity : 0);
    var qualifies = othersCount > 0 && cart.items_subtotal_price >= gift;

    var url = null;
    var body = null;

    if (qualifies && !line) {
      url = '/cart/add.js';
      body = {
        items: [{ id: giftVariant, quantity: 1 }],
        sections: SECTIONS,
        sections_url: window.location.pathname
      };
    } else if (line && !qualifies) {
      url = '/cart/change.js';
      body = {
        id: line.key,
        quantity: 0,
        sections: SECTIONS,
        sections_url: window.location.pathname
      };
    } else if (line && line.quantity !== 1) {
      url = '/cart/change.js';
      body = {
        id: line.key,
        quantity: 1,
        sections: SECTIONS,
        sections_url: window.location.pathname
      };
    }

    if (!url) return;

    busy = true;
    nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.sections) announce(data);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        refresh();
      });
  }

  function refresh() {
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        render(cart);
        sync(cart);
      })
      .catch(function () {});
  }

  function queueRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  ['cascade:modalcart:afteradditem', 'cascade:modalcart:cartqtychange'].forEach(
    function (name) {
      window.addEventListener(name, function () {
        if (!busy) queueRefresh();
      });
    }
  );

  window.fetch = function () {
    var arg = arguments[0];
    var url = '';
    try {
      url = String((arg && arg.url) || arg || '');
    } catch (err) {}
    var promise = nativeFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      promise.then(
        function () {
          if (!busy) queueRefresh();
        },
        function () {}
      );
    }
    return promise;
  };

  function boot() {
    if (!bars().length && initTries < 20) {
      initTries += 1;
      setTimeout(boot, 400);
      return;
    }
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();